'use client';

import classnames from 'classnames';

import type { MeterProps } from './Meter.types';

import styles from './Meter.module.scss';

export function Meter({
  ref,
  style,
  className,
  value,
  variant = 'primary',
  label = 'Progreso',
  testId = 'ui-meter',
  ...rest
}: MeterProps) {
  const clamped = Number.isFinite(value)
    ? Math.min(100, Math.max(0, value))
    : 0;

  return (
    <div
      ref={ref}
      style={style}
      className={classnames(
        styles['meter'],
        styles[`meter--${variant}`],
        className,
      )}
      role="progressbar"
      aria-label={label}
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
      data-testid={testId}
      {...rest}
    >
      <div className={styles['meter__bar']} style={{ width: `${clamped}%` }} />
    </div>
  );
}
